import BaseService from '@/services-ts/BaseService'
import type { ICompanySettings } from '@/types/Data'
import type { IPayloadCompanySetting } from '@/types/Request'

export default class LevelServices extends BaseService {
  GetLevelList() {
    return this.GET<ICompanySettings[]>(this.PATHS.GET_LEVEL_LIST)
  }

  CreateLevel(Name: string) {
    return this.POST<ICompanySettings>(this.PATHS.CREATE_LEVEL, { Name })
  }

  UpdateLevel(payload: IPayloadCompanySetting) {
    return this.POST<ICompanySettings>(this.PATHS.UPDATE_LEVEL, payload)
  }

  DeleteLevel(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_LEVEL, { Id })
  }
}
